import LightBoard from "./LightBoard";
import DarkBoard from "./DarkBoard";

const FIELD_SCALE = 1.15;
const vh = (n) => +(n * FIELD_SCALE).toFixed(3) + "vh";

const DUAL_SCALE = 1.2;
const dvh = (n) => +(n * FIELD_SCALE * DUAL_SCALE).toFixed(3) + "vh";

const cfg = {
  pad: "2.8vh 2.5vw",
  iconSize: vh(4.7),
  iconBox: vh(7.8),
  titleSize: vh(6.8),
  airportSize: vh(2.6),
  clockSize: vh(3.1),
  headSize: vh(2),
  rowSize: vh(3.25),
  badgeSize: vh(4.4),
  badgeFont: vh(1.75),
  cols: "8% 9% 12% 44% 12% 15%",
  dualPad: "2vh 1.6vw",
  dualDir: "row",
  dualCols: "12% 15% 39% 14% 20%",
  dualTitleSize: dvh(4.2),
  dualAirportSize: dvh(1.8),
  dualClockSize: dvh(2.2),
  dualHeadSize: dvh(1.35),
  dualRowSize: dvh(2),
  dualBadgeSize: dvh(2.8),
  dualBadgeFont: dvh(1.15),
  dualIconBox: dvh(5),
  dualIconSize: dvh(3.2),
  dualRowMin: dvh(3.4),
  sectionIconBox: dvh(2.8),
  sectionIconSize: dvh(1.9),
  sectionTitleSize: dvh(1.7),
  statusColWidth: "15%",
};

const Landscape = (props) => {
  const Board = props.theme === "dark" ? DarkBoard : LightBoard;
  return <Board {...props} cfg={cfg} />;
};

export default Landscape;
